/* tslint:disable */
/* eslint-disable */
/**
 * Neptune Leaderboard REST API
 * Public REST API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: contact@neptune.ml
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SeriesAttributeSourceDTO } from './SeriesAttributeSourceDTO';
import {
    SeriesAttributeSourceDTOFromJSON,
    SeriesAttributeSourceDTOFromJSONTyped,
    SeriesAttributeSourceDTOToJSON,
} from './SeriesAttributeSourceDTO';

/**
 * 
 * @export
 * @interface SeriesAttributeWithSourceDTO
 */
export interface SeriesAttributeWithSourceDTO {
    /**
     * 
     * @type {string}
     * @memberof SeriesAttributeWithSourceDTO
     */
    attribute: string;
    /**
     * 
     * @type {SeriesAttributeSourceDTO}
     * @memberof SeriesAttributeWithSourceDTO
     */
    source: SeriesAttributeSourceDTO;
}

/**
 * Check if a given object implements the SeriesAttributeWithSourceDTO interface.
 */
export function instanceOfSeriesAttributeWithSourceDTO(value: object): value is SeriesAttributeWithSourceDTO {
    if (!('attribute' in value) || value['attribute'] === undefined) return false;
    if (!('source' in value) || value['source'] === undefined) return false;
    return true;
}

export function SeriesAttributeWithSourceDTOFromJSON(json: any): SeriesAttributeWithSourceDTO {
    return SeriesAttributeWithSourceDTOFromJSONTyped(json, false);
}

export function SeriesAttributeWithSourceDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): SeriesAttributeWithSourceDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'attribute': json['attribute'],
        'source': SeriesAttributeSourceDTOFromJSON(json['source']),
    };
}

export function SeriesAttributeWithSourceDTOToJSON(value?: SeriesAttributeWithSourceDTO | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'attribute': value['attribute'],
        'source': SeriesAttributeSourceDTOToJSON(value['source']),
    };
}

